var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55664 8.24875H4.26289V5.265H1.55664V8.24875ZM2.33789 6.12437H3.48164V7.3825H2.33789V6.12437ZM6.91914 5.265C6.51634 5.265 6.13004 5.44101 5.84522 5.75431C5.5604 6.06762 5.40039 6.49255 5.40039 6.93563V9.27313H6.18789V6.93563C6.17846 6.82328 6.19043 6.71 6.22305 6.60304C6.25567 6.49607 6.30821 6.39776 6.37732 6.31439C6.44643 6.23103 6.53059 6.16444 6.62443 6.11887C6.71826 6.07331 6.8197 6.04977 6.92227 6.04977C7.02483 6.04977 7.12627 6.07331 7.22011 6.11887C7.31394 6.16444 7.3981 6.23103 7.46721 6.31439C7.53632 6.39776 7.58886 6.49607 7.62148 6.60304C7.6541 6.71 7.66607 6.82328 7.65664 6.93563V9.27313H8.43789V6.93563C8.43789 6.49255 8.27788 6.06762 7.99306 5.75431C7.70824 5.44101 7.32194 5.265 6.91914 5.265ZM1.55664 3.48438H8.43789V4.37812H1.55664V3.48438Z",
    fill: "#FCFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.825 1.72656H1.175C0.863371 1.72656 0.564505 1.86274 0.34415 2.10513C0.123794 2.34752 0 2.67627 0 3.01906L0 9.27531H0.78125V3.01906C0.78125 2.90419 0.822734 2.79402 0.896577 2.7128C0.970419 2.63157 1.07057 2.58594 1.175 2.58594H8.825C8.92943 2.58594 9.02958 2.63157 9.10342 2.7128C9.17727 2.79402 9.21875 2.90419 9.21875 3.01906V9.27531H10V3.01906C10 2.67627 9.87621 2.34752 9.65585 2.10513C9.4355 1.86274 9.13663 1.72656 8.825 1.72656Z",
    fill: "#FCFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/department_Icon.a9c495d7168b851f100264322a92f71c.svg";
export { ForwardRef as ReactComponent };